import { Box, CircularProgress, Portal, Typography } from "@mui/material";

const styles = {
  layout: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "black",
    opacity: 0.5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export default function Loading({ title }: any) {
  return (
    <Portal>
      <Box sx={styles.layout}>
        <CircularProgress />
        {title && (
          <Typography sx={{ mt: 1, color: "white" }}>{title}</Typography>
        )}
      </Box>
    </Portal>
  );
}
